import { createFileRoute } from '@tanstack/react-router';

import { coinPackagesQueryOptions } from '@/features/coins/api';
import { CheckoutPage } from '@/features/coins/components/checkout-page';
import { coinSelectionSearchSchema } from '@/features/coins/selection';
import { meQueryOptions } from '@/features/me/api';

export const Route = createFileRoute('/_app/_auth/checkout')({
  validateSearch: coinSelectionSearchSchema,
  staticData: { title: '결제하기' },
  loader: ({ context }) =>
    Promise.all([
      context.queryClient.query({ ...coinPackagesQueryOptions(), staleTime: 'static' }),
      context.queryClient.query({ ...meQueryOptions(), staleTime: 'static' }),
    ]),
  // 결제위젯에 고객 키(GET /me)가 필요해 둘 다 기다린다
  head: () => ({ meta: [{ title: '결제하기 · 팬즈드롭 코인 충전' }] }),
  component: CheckoutRoute,
});

function CheckoutRoute() {
  return <CheckoutPage search={Route.useSearch()} />;
}
